<template>
    <div class="flex align-center">
        <gj-dropdown class="tab--close__dropdown" trigger="click" style="display: flex;align-items: center">
                            <span class="custom-view">
                              <template v-if="clientWidth <= 1440">
                                 <gj-button type="icon"> <i class="el-icon-view" style="font-size: 16px"></i></gj-button>
                              </template>
                              <template v-if="clientWidth > 1440">
                                 <div style="display: flex;align-items: center">
                                    <i class="el-icon-view" style="font-size: 16px; margin-right: 6px; color: #8091a5;"></i>
                                      <span style="font-size: 12px; color: #8091a5;">视图</span>
                                     <span style="margin-left: 10px; color: #444">
                                    <gj-text max-width="7em">{{ viewName }}</gj-text>
                                   <i class="el-icon-arrow-down el-icon--right"></i></span>
                                 </div>
                              </template>
                            </span>
            <template #dropdown>
                <gj-dropdown-item :class="{'active': index === -1}" @click="handleResetView">默认</gj-dropdown-item>
                <template v-if="viewData && viewData.length">
                    <gj-dropdown-item :class="{ 'active': view && item.id === view.id}" v-for="(item, idx) in viewData" :key="item.id" @click="handleCustomView(item, idx)">{{ item.name }}</gj-dropdown-item>
                </template>
                <gj-dropdown-item @click="handleAddView">
                    <i class="el-icon-plus"></i>
                    <span>添加视图</span>
                </gj-dropdown-item>
                <gj-dropdown-item @click="handleViewList">
                    <i class="el-icon-setting"></i>
                    <span>配置视图</span>
                </gj-dropdown-item>
            </template>
        </gj-dropdown>


        <view-list-component
            :visible.sync="visibleListComponent"
            :module-name="moduleName"
            :data="viewData"
            :save-mode="saveMode"
            @edit="handleAddView"
            @refresh="listRefresh"
        >
        </view-list-component>
        <view-add-component
            :visible.sync="visibleAddComponent"
            :config="model"
            :module-name="moduleName"
            :form-data="formData"
            :form-rows="formRows"
            :form-rules="rules"
            :current="current"
            :save-mode="saveMode"
            :fnGenerateParams="fnGenerateParams"
            @custom-confirm="handleAddConfirm"
        >
            <div :slot="item.prop" v-for="item in formRows" :key="item.prop">
                <slot :name="item.prop" :form-data="formData" :config="model" :form-row="item">
                    <template v-if="item.components && !item.slot && !$scopedSlots[item.prop]">
                        <component
                            v-for="component in buildComponentParams(item.components)"
                            :key="component.prop"
                            :is="component.name"
                            v-model="formData[component.prop]"
                            v-bind="component.propsData"
                            v-on="buildComponentListeners(component.listeners)"
                        ></component>
                    </template>
                </slot>
            </div>
        </view-add-component>
    </div>
</template>

<script>
    import {
        getViewList,
        putEditView,
        setDefaultView,
        putSetDefaultView,
    } from "@/api/common";
    import {type} from "@/utils/common";
    import ViewAddComponent from "@/views/components/view-setting/view-add";
    import ViewListComponent from "@/views/components/view-setting/view-list"
    import TtlLocalStorage from "@/utils/storage";

    const storage = new TtlLocalStorage({
        namespace: 'VIEW'
    });

    export default {
        name: "view-setting",
        props: {
            // 初始化设置
            activeIndex: {
                type: Number,
                default: -1
            },
            // 是否使用select值为true的视图，当该选项为true且存在select值为true的视图时，activeIndex会失效
            useDefault: {
                type: Boolean,
                default: false
            },
            // 视图模块名
            moduleName: {
                type: String,
                required: true
            },
            // 视图添加/编辑配置
            config: {
                type: [Array, Function],
                required: true
            },
            // 参数构造
            fnGenerateParams: {
                type: Function
            },
            // 视图存储模式
            saveMode: {
                type: String,
                validator(val) {
                    return ['local', 'remote', 'mix'].includes(val)
                },
                default: 'remote'
            },
            // 缓存配置项
            cacheOptions: {
                type: Object,
                default: () => ({})
            },
        },
        components: {
            ViewAddComponent,
            ViewListComponent
        },
        data () {
            return {
                viewData: [], // 视图名称列表
                view: null, // 选中的视图
                index: -1,
                formData: {},
                rules: {},
                formRows: [],
                model: {},
                visibleAddComponent: false,
                visibleListComponent: false,
                current: null,
                cacheModuleName: `CACHE_${this.moduleName}`,
                defaultConfig: {
                    prop: 'name',
                    label: '视图名称',
                    isFormItem: true,
                    components() {
                        return [{
                            name: 'gj-input',
                            prop: 'name',
                            propsData: {
                                placeholder: '请输入视图名称',
                                style: {
                                    width: '256px'
                                }
                            }
                        }]
                    },
                    validator: [
                        {required: true, message: '请输入视图名称', trigger: 'change'},
                        {
                            validator: (rule , value, callback) => {
                                if (!value.trim()) {
                                    callback(new Error('请输入视图名称'))
                                }

                                if (value && value.length > 32) {
                                    callback(new Error('视图名称长度限制为32'))
                                }

                                callback()
                            }
                        }
                    ],
                    labelWidth: '120px',
                    defaultValue: ''
                }
            }
        },
        computed: {
            viewName ({ index = -1, viewData = [] }) {
                return index === -1
                    ? '默认'
                    : (viewData && viewData.length
                        ? viewData[index].name
                        : '默认')
            }
        },
        created () {
            this.initFields()
            this.getViewList().then(res => {
                this.$emit('view-complete', res)
            })
        },
        methods: {
            /**
             * 初始化视图添加/编辑配置
             */
            initFields(mode = 'add') {
                const config = type(this.config) === 'array' ? this.config : this.config.call(this)
                const hasNameConfig = config.findIndex(v => v.prop === this.defaultConfig.prop)

                if (hasNameConfig >= 0) {
                    config.shift()
                }
                config.unshift(this.defaultConfig)

                // 表单校验
                let rules = {}
                // form对象
                let data = {}
                // 表单行
                let formRows = []
                config.forEach(v => {
                    if (v.validator) {
                        rules[v.prop] = v.validator
                    }
                    if (v.isFormItem) {
                        formRows.push(v)
                    }
                    data[v.prop] = mode === 'add' ?  v.defaultValue ?? '' : this.formData[v.prop] ?? v.defaultValue ?? ''
                })
                this.rules = rules
                this.formRows = formRows
                this.formData = data
                this.model = config
            },
            buildComponentParams (components) {
                return type(components) === 'function' ? components.call(this) : components
            },
            buildComponentListeners (listeners) {
                return type(listeners) === 'function' ? listeners.call(this) : (listeners ?? {})
            },
            /**
             * 获取对应模块的视图列表
             */
            async getViewList(useCache = true) {
                return new Promise(async (resolve, reject) => {
                    const saveMode = this.saveMode
                    let viewList = []
                    switch (saveMode) {
                        case 'local': {
                            viewList = await storage.get(this.moduleName)
                            break;
                        }
    
                        case 'remote': {
                            viewList = await getViewList(this.moduleName)
                            break;
                        }
    
                        case 'mix': {
                            const localData= await storage.get(this.moduleName)
                            const remoteData = await getViewList(this.moduleName)
                            const mergeData = localData.concat(remoteData)
                            const map = new Map()
                            mergeData.forEach(v => {
                                if (!map.has(v.name)) {
                                    map.set(v.name, v)
                                } else {
                                    v.id && map.set(v.name, v)
                                }
                            })
                            viewList = Array.from(map.values())
                            break;
                        }
                    }
    
                    if (viewList && viewList.length) {
                        this.index = this.activeIndex
                        this.view = this.index >= 0 ? viewList[this.index] : null
                        if (this.useDefault) {
                            for (let i = 0; i < viewList.length; i++) {
                                if (viewList[i].selected) {
                                    this.index = i
                                    this.view = viewList[i]
                                    break;
                                }
                            }
                        }
                    }
                    this.viewData = viewList
                    // let cacheData = await this.$cache.getCache(this.moduleName)
                    // const viewData = useCache && cacheData && cacheData.params ? cacheData : this.view
                    resolve(this.view)
                })
            },

            getViewData() {
                const s = this.getCacheData()
                let opt = {}
                if (this.cacheOptions.useCache && s) {
                    opt = s.query || {}
                } else {
                    opt = this.view
                }
                return opt
            },
            getCacheData() {
                return this.$cacheQuery.getCache({key: this.cacheOptions.key})
            },
            /**
             * 获取视图详情
             */
            getViewDetail () {
                const current = this.current
                try {
                    if (current) {
                        let params = current.params ? JSON.parse(current.params) : {}
                        this.formData = Object.assign({}, this.formData, params)
                        this.initFields('edit')
                    } else {
                        this.initFields('add')
                    }
                } catch (e) {
                    console.log(e)
                }
                this.visibleAddComponent = true
            },
            /**
             * 设置默认视图
             */
            putSetDefaultView,
            /**
             * 编辑视图
             */
            putEditView,
            /**
             * 切换视图
             */
            handleCustomView (view, idx) {
                this.$cacheQuery.removeCache()
                this.$cacheTab.removeCache()
                if (view && view.params) {
                    this.index = idx
                    this.view = view
                    this.$emit('view-change', view)
                    if (view.id && this.saveMode === 'remote') {
                        putSetDefaultView(view.id)
                    }
                }
                this.$nextTick(_ => {
                    this.$cacheQuery.removeCache()
                    this.$cacheTab.removeCache()
                })
            },
            /**
             * 重置视图
             */
            handleResetView () {
                this.$cacheQuery.removeCache()
                this.$cacheTab.removeCache()
                this.index = -1
                this.view = null
                // 重置默认视图
                setDefaultView({
                    module: this.moduleName
                })
                // 清除缓存
                this.$cache.setCache(this.moduleName, this.view)
                this.$emit('view-change', null)
                this.$nextTick(_ => {
                    this.$cacheQuery.removeCache()
                    this.$cacheTab.removeCache()
                })
            },
            /**
             * 打开添加视图弹窗
             * @param row
             */
            handleAddView (row) {
                this.current = row
                this.getViewDetail()
            },
            /**
             * 点击新增/编辑视图弹窗确认按钮
             */
            handleAddConfirm () {
                this.visibleAddComponent = false
                this.getViewList().then(res => {
                    this.$emit('view-change', this.view)
                })
            },
            /**
             * 打开视图列表
             */
            handleViewList () {
                this.visibleListComponent = true
            },
            listRefresh() {
                this.getViewList().then(_ => {
                    this.$emit('view-change', this.view)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .active {
        color: #1F6EEF;
    }
    .viewName{
      margin-left: 10px;
      color: #333;
      max-width: 84px;
    }
    /deep/ .el-dropdown{
      font-size: 12px;
    }
</style>
